import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum SemanticRuleAction {
	Delete = 'delete',
}

export interface ISemanticRuleActionModalData {
	semanticRuleId: number | Array<number>;
	element: string;
	action: SemanticRuleAction;
}
@Component({
	selector: 'app-semantic-rule-action-popup',
	templateUrl: './semantic-rule-action-popup.component.html',
	styleUrls: ['./semantic-rule-action-popup.component.scss'],
})
export class SemanticRuleActionPopupComponent<
	T extends ISemanticRuleActionModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly SemanticRuleAction = SemanticRuleAction;
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		semanticRuleId: number | Array<number>;
		isMultipleElement: boolean;
		action: SemanticRuleAction;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'semantic-rule-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.semanticRuleId) &&
				this.modalData.element === '',
			semanticRuleId: this.modalData.semanticRuleId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
